export default __webpack_public_path__ + "9badb7bd43368ef63e792ce73e74588d.svg";